import { useState, Fragment, useCallback } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  label?: React.ReactNode;
  confirmTitle?: React.ReactNode;
  confirmMessage?: React.ReactNode;
  children?: React.ReactNode;
  onClick?: (...args: unknown[]) => void;
  buttonComponent?: React.ElementType;
  [key: string]: unknown;
};

const ConfirmButton = (props: Props) => {
  const {
    buttonComponent: ButtonComponent = Button,
    confirmTitle = 'Please Confirm',
    confirmMessage = 'Are you sure?',
    children,
    onClick,
    label,
    ...buttonProps
  } = props;
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback((e) => {
    e.preventDefault();
    setOpen(true);
  }, []);

  const handleCancel = useCallback((e) => {
    e.preventDefault();
    setOpen(false);
  }, []);

  const handleConfirm = useCallback((e) => {
    setOpen(false);
    onClick(e);
  }, [onClick]);

  return (
    <Fragment>
      <ButtonComponent onClick={handleClickOpen} {...buttonProps}>
        {label}
      </ButtonComponent>
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{confirmTitle}</DialogTitle>
        <DialogContent>
          {children ? (
            <div id="alert-dialog-description">
              {children}
            </div>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {confirmMessage}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ConfirmButton;
